export default "__VITE_ASSET__Db8N20FM__"